<template>
  <div class="otp-container" dir="ltr">
    <input
      v-for="(_, index) in digits"
      :key="index"
      ref="otpInputs"
      type="text"
      inputmode="numeric"
      autocomplete="one-time-code"
      maxlength="1"
      class="otp-input"
      :class="{ filled: digits[index] }"
      :value="digits[index]"
      @input="onInput(index, $event)"
      @keydown="onKeydown(index, $event)"
      @paste="onPaste"
    />
  </div>
</template>

<script>
const OTP_LENGTH = 6;

export default {
  emits: ["update-otp"],
  data() {
    return {
      digits: Array(OTP_LENGTH).fill(""),
    };
  },
  methods: {
    emitOtp() {
      this.$emit("update-otp", this.digits.join(""));
    },
    focusInput(index) {
      const input = this.$refs.otpInputs?.[index];
      if (input) input.focus();
    },
    clear() {
      this.digits = Array(OTP_LENGTH).fill("");
      this.emitOtp();
      this.focusInput(0);
    },
    onInput(index, event) {
      const value = event.target.value.replace(/\D/g, "");
      this.digits[index] = value.slice(-1);
      event.target.value = this.digits[index];
      this.emitOtp();

      if (this.digits[index] && index < OTP_LENGTH - 1) {
        this.focusInput(index + 1);
      }
    },
    onKeydown(index, event) {
      if (event.key === "Backspace" && !this.digits[index] && index > 0) {
        this.focusInput(index - 1);
      }
    },
    onPaste(event) {
      event.preventDefault();
      const pasted = event.clipboardData
        .getData("text")
        .replace(/\D/g, "")
        .slice(0, OTP_LENGTH);

      pasted.split("").forEach((char, index) => {
        this.digits[index] = char;
      });

      this.emitOtp();
      this.focusInput(Math.min(pasted.length, OTP_LENGTH - 1));
    },
  },
  mounted() {
    this.focusInput(0);
  },
};
</script>

<style scoped>
.otp-container {
  display: flex;
  gap: 10px;
  justify-content: center;
  width: 100%;
}

.otp-input {
  width: 44px;
  height: 52px;
  border: 1px solid #dfdfe5;
  border-radius: 8px;
  text-align: center;
  font-size: 20px;
  font-family: var(--font-family);
  color: #111827;
  background: #fff;
  outline: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.otp-input:focus,
.otp-input.filled {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px var(--primary-alpha);
}

@media (max-width: 768px) {
  .otp-container {
    gap: 8px;
  }

  .otp-input {
    width: 40px;
    height: 48px;
    font-size: 18px;
  }
}
</style>
